import React from 'react';
import { Typography } from 'housecall-ui';

import { Cart } from '../components/Cart/Cart';
import { Layout } from '../components/Layout';
import { ServiceList } from '../components/ServicesList';
import { StepProgressBar } from '../components/StepProgressBar';
import { useChangeStep } from '../hooks/useChangeStep';
import { useOnlineBookingReducer } from '../state/useOnlineBookingReducer';

import { BackArrowButton } from './BackArrowButton';

export const ServiceStep = () => {
  const {
    state: { industry, category, subcategory, secondStepSkipped },
  } = useOnlineBookingReducer();
  const hasSubCategory = Boolean(subcategory);
  const { dispatch, actions } = useOnlineBookingReducer();
  const { changeStep } = useChangeStep();

  const handleBackClick = () => {
    if (!hasSubCategory || category?.subcategories?.length === 1) {
      changeStep('categories');
    } else {
      changeStep('sub-categories');
    }
    dispatch(actions.resetSubCategory());
  };

  return (
    <Layout
      ContentComponent={
        <>
          {!secondStepSkipped ? <BackArrowButton onClick={handleBackClick} /> : null}
          <Typography gutterBottom variant="h5">
            What can we do for you?
          </Typography>
          <Typography gutterBottom variant="subtitle1" data-testid="service-step-header">
            {industry?.name} / {category?.name}
            {hasSubCategory && ` / ${subcategory?.name}`}
          </Typography>
          <ServiceList />
        </>
      }
      Header={
        <>
          <StepProgressBar currentStep={1} stepCount={5} />
          <Cart />
        </>
      }
    />
  );
};

ServiceStep.hiddenButtons = true;
